export const APPLY_CHANGES = 'manage/almasync/changes/apply';
export const IGNORE_CHANGES = 'manage/almasync/changes/ignore';
export const CREATE_RECORD_URL = 'profiles/';
export const TRACK_ACTIONS_API_PATH = '/websites/admin_action';